export default class AddController {
  constructor(CouponsDataProvider, $state) {
    "ngInject"
    this.CouponsDataProvider = CouponsDataProvider;
    this.$state = $state;
    let
      vm = this;
    vm.couponTypes = [{'id': 1, 'name': 'Percentage'}, {'id': 2, 'name': 'Flat'}];
    vm.CouponsDataProvider.getCoupon(vm.$state.params.id).then(function (result) {
      vm.coupon = result;
    });
  }

  update(form) {
    if (!form) {
      return false;
    }
    let
      vm = this;
    vm.CouponsDataProvider.updateCoupon(vm.coupon, vm.coupon.id).then(function (res) {
      if (res.exist == '1') {
        vm.existRecord = 1;
      }
      else {
        vm.$state.go('app.couponlisting');
      }
    })

  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/components/edit/controller.js
 **/